import getApi from '../../../api'
import { ApiErrorContent } from '../../../model/Error'
import { OrganizationInterop } from '../../../model/OrganizationInterop'
import { serializeOrganizationInteropUpdate } from './organizationInterop.mapper'

export const postOrganizationInterop = (organizationInterop: Partial<OrganizationInterop>) =>
  getApi().post<OrganizationInterop, ApiErrorContent>(
    '/admin/interop/organizations',
    serializeOrganizationInteropUpdate(organizationInterop),
  )
